import { Injectable, OnDestroy } from '@angular/core'
import { Observable, Subscription } from 'rxjs'

import { AEMService } from '../AEM/aem-content.service'
@Injectable({
  providedIn: 'root',
})
export class CentralContentService implements OnDestroy {
  aemContent$: Observable<any>
  aemContent: any
  aemContentValue: string
  aemContentSub: Subscription

  constructor(private readonly aemService: AEMService) {}
  public load() {
    //Preparing the AEM Content for use by loading it in advance
    this.aemContent$ = this.aemService.getAEMContent()
    this.aemContentSub = this.aemContent$.subscribe(
      (params) => {
        this.aemContent = params
      },
      (error) => {
        console.log(error)
      },
    )
  }
  //Used by components to parse out fragments from given body (always called in subscribes)
  getContentByBody(contentFragmentName: string, jsonBody: any): any {
    let _contentValue = jsonBody.Data[`${contentFragmentName}`]?.content?.text
    if (_contentValue) {
      _contentValue = this.formatLink(_contentValue)
      return { contentValue: _contentValue, isAEM: true }
    } else {
      return { contentValue: '', isAEM: false }
    }
  }
  //Used in cases where components will call only when AEM is finished loading
  getContent(contentFragmentName: string): any {
    this.aemContentValue =
      this.aemContent.Data[`${contentFragmentName}`]?.content?.text
    if (this.aemContentValue) {
      this.aemContentValue = this.formatLink(this.aemContentValue)
      return {
        contentValue: this.aemContentValue,
        isAEM: true,
      }
    } else {
      return { contentValue: '', isAEM: false }
    }
  }
  ngOnDestroy(): void {
    if (this.aemContentSub) {
      this.aemContentSub.unsubscribe()
    }
  }
  formatLink(str) {
    const from = [
      '&lt;',
      '&gt;',
      '&amp;',
      '&quot;',
      '>nbsp;',
      '<br>',
      '%7B',
      '%7D',
      '{{',
      '}}',
    ]
    const to = ['<', '>', '&', '"', ' ', '\n', '', '', '', '']
    from.forEach((data, index) => {
      str = this.regularExpression(str, data, to[index])
    })
    return str
  }
  regularExpression(str, find, replace) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
    return str.toString().replace(new RegExp(escapedFind, 'g'), replace)
  }
}
